import BaseActionAbstract from 'cio/app-models/action-abstracts/base';
import { task } from 'ember-concurrency';

const EDITABLE_PROPERTIES = [];
const DIRTY_DEPENDENCIES = `action.{${EDITABLE_PROPERTIES.join(',')}}`;

export default BaseActionAbstract.extend({
  type: 'exit',

  action: null,
  actionType: null,
  _editableProperties: EDITABLE_PROPERTIES,
  _dirtyDependencies: DIRTY_DEPENDENCIES,

  preconditions: null,

  prepareForEdit() {
    this._super(...arguments);
  },

  prepareForSave() {
    let action = this._super(...arguments);

    return action;
  },

  // eslint-disable-next-line require-yield
  saveTask: task(function* () {
    let action = this.prepareForSave();

    try {
      // let response = yield action.save();
      // this.prepareForEdit();
      // return response;
      return action;
    } catch (e) {
      action.rollbackAttributes();
      throw e;
    }
  }).drop(),

  // eslint-disable-next-line require-yield
  deleteTask: task(function* () {
    return this.action.campaign.removeActionFromWorkflow(this.action);
    // return yield this.action.deleteViaAPI();
  }).drop(),

  init() {
    this._super(...arguments);

    this.preconditions = this.preconditions ?? [];
  },
});
